import script from "./AchievementLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementLibrary.vue?vue&type=script&setup=true&lang=js"

import "./AchievementLibrary.vue?vue&type=style&index=0&id=2de5fb02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de5fb02"]])

export default __exports__